import './AboutMe.scss';
// Component 
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import Image from '../components/Image/Image';
import Wppbtn from '../components/Wppbtn/Wppbtn';
// Metadata Component 
import MetaTags from '../components/MetaTags/MetaTags';
// Images
import nutricionistaJPG from '../assets/images/sobre-mi-nutri.jpg';
import nutricionistaMobileJPG from '../assets/images/sobre-mi-mobile.jpg';
import nutricionistaWebp from '../assets/images/sobre-mi-nutri.webp';
import nutricionistaMobileWebp from '../assets/images/sobre-mi-mobile.webp';

function Aboutme() {
  return (
    <div className="about-me">
      <MetaTags
                title='Licenciada en Nutrición Belén Olivera | Sobre Mí'
                description='Mi nombre es Belén Olivera, soy Licenciada en Nutrición de la Universidad de la Republica. Actualmente resido en Rivera, Uruguay. Descubre más sobre mí en esta página. ¡Hagamos de tu bienestar una prioridad y comencemos esta transformación juntos!'
                image='images/logotipo-white-desktop.png'
                name='Lautaro Tamborindeguy'
            />
      <Header />
      <main className="container">
        <div className="content">
          <Image pngDesktopSrc={nutricionistaJPG} pngMobileSrc={nutricionistaMobileJPG} webpDesktopSrc={nutricionistaWebp} webpMobileSrc={nutricionistaMobileWebp} alt="Nutricionista María Belén Olivera" width={331} height={496} loading="eager" />
          <div className="text">
            <h1>¿Quién soy?</h1>
            <p>Hola, soy Belén Olivera, Licenciada en Nutrición, y creo profundamente que la alimentación no debería ser una lucha diaria, sino una forma de cuidarnos y disfrutarnos.</p>
            <p>Acompaño a mujeres que se sienten cansadas de empezar y abandonar dietas, que cargan con la culpa cada vez que comen algo que disfrutan y que ya no saben cómo volver a confiar en sí mismas.</p>
            <p>Mi enfoque no se trata de restricciones ni de contar calorías, sino de recuperar la paz con la comida, aprender a escuchar tu cuerpo y construir un vínculo más sano y amable con vos misma.</p>
            <p>Creo en un proceso real y humano: bajar de peso sin dejar de vivir, volver a disfrutar de lo que comés y sentirte bien por dentro y por fuera. Porque el verdadero cambio no está solo en el plato, sino también en cómo te acompañás a vos misma en el camino.</p>
            <p>¡Hagamos de tu bienestar una prioridad y comencemos esta transformación juntas!</p>
          </div>
        </div>
      </main>
      <Footer />
      <Wppbtn />
    </div>
  );
}

export default Aboutme;